/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { NavigateOptions, useSearchParams } from "react-router-dom";

export function useQueryParam<T>(
  key: string
): [T | undefined, (newQuery: T, options?: NavigateOptions) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramValue = searchParams.get(key);

  const value: any = React.useMemo(() => paramValue || null, [paramValue]);

  const setValue = React.useCallback(
    (newValue: T, options?: NavigateOptions) => {
      const newSearchParams = new URLSearchParams(window.location.search.substring(1));
      newSearchParams.set(key, String(newValue));
      setSearchParams(newSearchParams, options);
    },
    [key, setSearchParams]
  );

  return [value, setValue];
}
